import { render, staticRenderFns } from "./features-summary-page.vue?vue&type=template&id=27466519&scoped=true&"
import script from "./features-summary-page.vue?vue&type=script&lang=js&"
export * from "./features-summary-page.vue?vue&type=script&lang=js&"
import style0 from "./features-summary-page.vue?vue&type=style&index=0&id=27466519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27466519",
  null
  
)

export default component.exports